import { useState, useEffect } from 'react';

export const useApiUsageStatus = () => {
  const [usageStatus, setUsageStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsageStatus = async () => {
    try {
      // Endpoint défini dans backend/api/usage_status.py
      const response = await fetch('/api/usage/status');
      if (!response.ok) {
        throw new Error('Erreur HTTP ' + response.status);
      }
      const data = await response.json();
      setUsageStatus(data);
      setError(null);
    } catch (err) {
      console.error('Erreur lors du chargement du statut API', err);
      setError('Impossible de charger le statut de quota API.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsageStatus();
  }, []);

  return { usageStatus, loading, error, refetch: fetchUsageStatus };
};
